const KEY = "celia.recent-projects";
export function recentProjects(): string[] {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(KEY) ?? "[]");
    return Array.isArray(value) ? value.filter((slug): slug is string => typeof slug === "string").slice(0, 8) : [];
  } catch { return []; }
}
export function rememberProject(slug: string) {
  try { localStorage.setItem(KEY, JSON.stringify([slug, ...recentProjects().filter(value => value !== slug)].slice(0, 8))); } catch { /* Optional local navigation preference. */ }
}
export function orderProjects<T extends { slug: string; name: string }>(projects: T[], recent: string[]): T[] {
  return [...projects].sort((a, b) => {
    const rank = (slug: string) => { const i = recent.indexOf(slug); return i < 0 ? recent.length : i; };
    return rank(a.slug) - rank(b.slug) || a.name.localeCompare(b.name);
  });
}
